/**
 * @file JSON Editor - High-level router component
 * @version 1.0.0
 *
 * Routes to appropriate editor based on schema type and variant.
 */

import { createGetAttribute, DEFAULTS_KEY } from './attributes.js';
import { resolveEditor } from './component-registry.js';

export default {
  name: 'JSONEditor',
  inheritAttrs: false,

  props: {
    schema: {
      type: Object,
      required: true,
    },
    value: {
      required: true,
    },
    /**
     * Display variant:
     * - Arrays: 'list' (default), 'grid', 'table'
     * - Objects: 'list' (default), 'inline'
     */
    variant: {
      type: String,
      default: 'default',
    },
  },

  setup() {
    const injectedDefaults = Vue.inject(DEFAULTS_KEY, Vue.ref({}));
    return { injectedDefaults };
  },

  computed: {
    /**
     * Merged defaults
     */
    defaults() {
      return Vue.unref(this.injectedDefaults);
    },

    /**
     * Resolve component based on schema
     */
    resolvedComponent() {
      const variant = this.getAttribute('variant');
      // Merge variant from props/attrs into schema for resolution
      const schema = variant ? { ...this.schema, variant } : this.schema;
      return resolveEditor(schema, this.defaults);
    },

    /**
     * Props and attrs to pass through (excluding variant)
     */
    passThroughPropsAndAttrs() {
      return { ...this.$props, ...this.$attrs };
    },

    /**
     * Context-bound getAttribute function
     */
    getAttribute() {
      return createGetAttribute(
        this.schema,
        this.$props,
        this.$attrs,
        this.injectedDefaults
      );
    },
  },

  template: `
    <component
      :is="resolvedComponent"
      v-bind="passThroughPropsAndAttrs"
    />
  `,
};
